module.exports = __webpack_public_path__ + "static/sprite-custom-964a0ce08e824251731dd179749dcb27.svg";